import ColorSchemes from '../constants/ColorSchemes';
export const COLOR_SCHEME_STORAGE_KEY = 'mangools-color-scheme';
const VALID_SCHEMES = [ColorSchemes.LIGHT, ColorSchemes.DARK, ColorSchemes.AUTO];
const isValidColorScheme = value => VALID_SCHEMES.indexOf(value) !== -1;

// Reads accept both the raw enum string (classic apps) and AI Search Watcher's
// legacy zustand JSON envelope; writes always emit raw so the formats can't collide.
export const readSharedColorScheme = () => {
  let raw = null;
  try {
    raw = localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);
  } catch (e) {
    return null;
  }
  if (!raw) {
    return null;
  }
  if (isValidColorScheme(raw)) {
    return raw;
  }
  try {
    const parsed = JSON.parse(raw);
    const scheme = parsed && parsed.state ? parsed.state.colorScheme : undefined;
    return isValidColorScheme(scheme) ? scheme : null;
  } catch (e) {
    return null;
  }
};
export const writeSharedColorScheme = scheme => {
  if (!isValidColorScheme(scheme)) {
    return;
  }
  try {
    localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, scheme);
  } catch (e) {
    // ignore write failures (private mode, quota)
  }
};